import React, { useEffect, useState } from "react";
import { SliderNext, SliderPrev } from "../../../assets";
import { EMPTY_STRING, sliderConstants } from "../../../constants";

const { CONTROL_TYPE_NEXT, CONTROL_TYPE_PREV } = sliderConstants;

const SliderControls = ({
  length = 0,
  hideButtons = false,
  changeIndex = () => {},
  className = EMPTY_STRING,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    changeIndex(currentIndex);
    // eslint-disable-next-line
  }, [currentIndex]);

  const handleMoveSlider = (type) => {
    if (type === CONTROL_TYPE_NEXT) {
      if (currentIndex === length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    } else {
      if (currentIndex === 0) {
        setCurrentIndex(length - 1);
      } else {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };

  const handleGoToSpecificIndex = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      {length > 0 ? (
        <div
          className={`d-flex align-items-center justify-content-center mt-5 slider-container ${className}`}
        >
          {!hideButtons && (
            <div
              className="slider-button rounded-circle prev text-center pointer"
              onClick={() => handleMoveSlider(CONTROL_TYPE_PREV)}
            >
              <img src={SliderPrev} alt="previous" />
            </div>
          )}
          {Array.from({ length: length }, (_, index) => (
            <div
              className={`slider-dot rounded-circle pointer ${
                currentIndex === index ? "selected-slider-dot" : ""
              }`}
              onClick={() => handleGoToSpecificIndex(index)}
            />
          ))}
          {!hideButtons && (
            <div
              className="slider-button rounded-circle next text-center pointer"
              onClick={() => handleMoveSlider(CONTROL_TYPE_NEXT)}
            >
              <img src={SliderNext} alt="next" />
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SliderControls;
